module.exports = __webpack_public_path__ + "media/images/girl-753f889b.png";